import PropTypes from 'prop-types';
import KPICard from './KPICard.jsx';

export default function KPIGrid({ items, reportingPeriod, onClick }) {
    return (
        <div className="grid exec-pulse-kpi-grid">
            {items.map((item) => (
                <KPICard
                    key={item.kpiId || item.id || item.title}
                    item={item}
                    reportingPeriod={reportingPeriod}
                    onClick={onClick}
                />
            ))}
        </div>
    );
}

KPIGrid.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
    reportingPeriod: PropTypes.object,
    onClick: PropTypes.func.isRequired
};
